
import g from "../globals/variables";

const Navigation = {

  lastHeight: 0,

  init: () => {
    Navigation.hideMobileNavigation();
    window.addEventListener("resize", Navigation.hideMobileNavigation);

    g.el.navigation.trigger.addEventListener("click", Navigation.toggleMobileNavigation);

    g.el.navigation.links.forEach((link) => {
      link.addEventListener("click", Navigation.toggleRedirect);
    });

    Navigation.handleBackButtons();
  },

  handleBackButtons: () => { // TODO - tweak later with history tracking & url injection
    g.el.layout.querySelectorAll(".button--back").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        window.history.back();
      });
    });
  },

  hideMobileNavigation: () => {
    const currentHeight = window.innerHeight;
    const verticalResize = currentHeight !== Navigation.lastHeight;
    Navigation.lastHeight = currentHeight;

    if (!verticalResize) {
      g.el.header.classList.remove("header--navigation-active");
      document.documentElement.classList.remove("scroll--disabled");
    }
  },

  toggleMobileNavigation: () => {
    if (!g.el.header.classList.contains("header--navigation-active")) {
      g.el.header.classList.add("header--navigation-active");
      document.documentElement.classList.add("scroll--disabled");
    } else {
      g.el.header.classList.remove("header--navigation-active");
      document.documentElement.classList.remove("scroll--disabled");
    }
  },

  toggleRedirect: (event) => {
    event.preventDefault();

    const link = event.currentTarget;
    const url = link.getAttribute("href");

    if (g.el.loader) {
      setTimeout(() => {
        g.el.header.querySelectorAll(".navigation--sidebar .navigation__item--active").forEach((item) => {
          if (item) g.el.loader.content.classList.add("loader__content--orange");
        });

        setTimeout(() => {
          g.el.loader.content.classList.remove("loader__content--out");
          g.el.loader.content.classList.remove("loader__content--hidden");
          g.el.loader.content.classList.add("loader__content--left");
        }, 95);
      }, 5);
    }

    g.el.header.querySelectorAll(".navigation__item--active").forEach((item) => {
      item.classList.remove("navigation__item--active");
    });

    if (link.parentElement.classList.contains("navigation__item")) {
      link.parentElement.classList.add("navigation__item--active");
    }

    if (g.el.header.classList.contains("header--navigation-active")) {
      g.el.header.classList.remove("header--navigation-active");
      g.el.loader.content.classList.remove("loader__content--disabled");
    }

    setTimeout(() => {
      window.location.href = url;
    }, 300);
  },
};

export default Navigation;
